<!-- 常见问题 -->
<template>
    <div class="commonProblem">
        <div class="titleBOx">
               <h2 class="title">
                {{help.titel11}}
            </h2>
        </div>
        <div class="content"> 
            <h3 class="tip1"> {{help.titel12}}</h3>
            <h5 class="tip4"> {{help.titel13}}</h5>
            <p class="tip2 tip5"> {{help.titel14}}</p>
            <h5 class="tip4"> {{help.titel15}}</h5>
            <p class="tip2 tip5"> {{help.titel16}}</p>
            <!-- <h5 class="tip4"> {{help.titel17}}</h5>
            <p class="tip2 tip5"> {{help.titel18}}</p> -->
            <h5 class="tip4"> {{help.titel19}}</h5>
            <p class="tip2 tip5"> {{help.titel20}}</p>
            <h5 class="tip4"> {{help.titel21}}</h5>
            <p class="tip2 tip5"> {{help.titel22}}</p>

            <h3 class="tip1"> {{help.titel23}}</h3>
            <h5 class="tip4"> {{help.titel24}}</h5>
            <p class="tip2 tip5"> {{help.titel25}}</p>

            <h5 class="tip4"> {{help.titel26}}</h5>
            <p class="tip2"> {{help.titel27}}</p>
            <p class="tip2 tip6"> {{help.titel28}}</p>
            <p class="tip2"> {{help.titel29}}</p>
            <p class="tip2"> {{help.titel30}}</p>
            <p class="tip2"> {{help.titel31}}</p>
            <p class="tip2 tip6"> {{help.titel32}}</p>
            <p class="tip2"> {{help.titel33}}；</p>
            <p class="tip2 tip5"> {{help.titel34}}</p>

            <h5 class="tip4"> {{help.titel35}}</h5>
             <p class="tip2 tip6"> {{help.titel36}}</p>
            <p class="tip2 tip7"> {{help.titel37}}</p>
             <p class="tip2 tip6"> {{help.titel38}}</p>
            <p class="tip2 tip7"> {{help.titel39}}</p>
             <p class="tip2 tip6"> {{help.titel40}}</p>
            <p class="tip2 tip5"> {{help.titel41}}</p>

             <h5 class="tip4"> {{help.titel42}}</h5>
             <p class="tip2 tip6"> {{help.titel43}}</p>
            <p class="tip2 tip7"> {{help.titel44}}</p>
             <p class="tip2 tip6"> {{help.titel45}}</p>
            <p class="tip2 tip5"> {{help.titel46}}</p>

            <h5 class="tip4"> {{help.titel47}}</h5>
            <p class="tip2 tip5"> {{help.titel48}}</p>

            <h3 class="tip1"> {{help.titel49}}</h3>
            <h5 class="tip4"> {{help.titel50}}</h5>
            <p class="tip2"> {{help.titel51}}</p>
            <img loading="lazy" v-lazy="require('../../assets/images/yy/help8.jpg')" alt="" sizes="" srcset="" >
            <h5 class="tip4"> {{help.titel52}}</h5>
            <p class="tip2"> {{help.titel53}}</p>
            <p class="tip2"> {{help.titel54}}</p>
            <p class="tip2 tip5"> {{help.titel55}}</p>

            <h5 class="tip4"> {{help.titel56}}</h5>
            <p class="tip2"> {{help.titel57}} </p>
            <a class="tip2 tip6" target='_blank' href="http://www.macromedia.com/support/documentation/cn/flashplayer/help/settings_manager07.html">http://www.macromedia.com/support/documentation/cn/flashplayer/help/settings_manager07.html</a>
            <p class="tip2 tip5"> {{help.titel58}}</p>

            <h5 class="tip4"> {{help.titel59}}</h5>
            <p class="tip2 tip5"> {{help.titel60}}</p>

            <h5 class="tip4"> {{help.titel61}}</h5>
            <p class="tip2 tip5"> {{help.titel62}}</p>

            <h5 class="tip4"> {{help.titel63}}</h5>
            <p class="tip2 tip5"> {{help.titel64}}</p>
            <h5 class="tip4"> {{help.titel65}}</h5>
            <p class="tip2 tip5"> {{help.titel66}}</p>

            <h5 class="tip4"> {{help.titel67}}</h5>
            <p class="tip2 tip5"> {{help.titel68}}</p>
            <h5 class="tip4"> {{help.titel69}}</h5>
            <p class="tip2 tip5"> {{help.titel70}}</p>

            <h3 class="tip1"> {{help.titel71}}</h3>
             <h5 class="tip4"> {{help.titel72}}</h5>
            <p class="tip2 tip5"> {{help.titel73}}</p>
             <h5 class="tip4"> {{help.titel74}}</h5>
            <p class="tip2 tip5"> {{help.titel75}}</p>
             <h5 class="tip4"> {{help.titel76}}</h5>
            <p class="tip2 tip5"> {{help.titel77}}</p>

        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
        }
    },
    computed: {
        help() {
            return this.$t('help')
        }
    },
    methods:{
    },
    mounted(){

    }
}
</script>
<style scoped lang='scss'>
    .commonProblem{
        .titleBOx{
            border-bottom: 2px solid #f0f0f0;
            width: 100%;
            height: 60px;
            .title{
                line-height: 60px;
                margin-left: 30px;
                font-size: 24px;
                font-weight: 200;
                color: #e21;
            }
        }
        .content{
            padding: 30px 30px 50px;
            .tip1{
                padding: 15px 0px 20px;
                font-size: 18px;
                font-weight: 500;
                line-height: 30px;
                color: rgb(208, 25, 36);
            }
            .tip2{
                line-height: 28px;
                font-size: 14px;
                color: #666;
                .tip3{
                    color: #ec2828;
                }
            }
            .tip5{
                margin-bottom: 20px;
            }
            .tip7{
                margin-bottom: 10px;
            }
            .tip4{
                font-size: 15px;
                padding: 0px 0px 10px;
            }
            .tip6{
                color: rgb(0, 68, 153);
            }
            img{
                width: 100%;
                display: inline-block;
                margin-bottom: 30px;
            }
        }
    }
</style>